import React from "react";
import { createRoot } from "react-dom/client";
import "./styles.css";
import App from "./App";
import { ensureFreshCaches, APP_VERSION } from "./versioning";

ensureFreshCaches();

const root = createRoot(document.getElementById("root"));
root.render(<App />);

// Registro del Service Worker con recarga cuando hay una versión nueva de assets
if ("serviceWorker" in navigator) {
  if (process.env.NODE_ENV !== "production") {
    // Registrations are scoped to this origin (including localhost/IPv4/IPv6).
    // Only our root sw.js and valenpos-* caches belong to this application.
    const cleanDevelopmentWorker = async () => {
      const isValenposWorker = (worker) => {
        if (!worker?.scriptURL) return false;
        try {
          const url = new URL(worker.scriptURL, window.location.href);
          return url.origin === window.location.origin && url.pathname === "/sw.js";
        } catch { return false; }
      };
      const wasControlled = isValenposWorker(navigator.serviceWorker.controller);
      let registrationsCleaned = false;
      let cachesCleaned = false;
      try {
        const registrations = await navigator.serviceWorker.getRegistrations();
        const own = registrations.filter((reg) =>
          [reg.active, reg.waiting, reg.installing].some(isValenposWorker)
        );
        const results = await Promise.all(own.map((reg) => reg.unregister()));
        registrationsCleaned = results.every(Boolean);
      } catch (error) {
        console.warn("No se pudo limpiar el Service Worker de desarrollo", error);
      }
      try {
        if ("caches" in window) {
          const keys = await window.caches.keys();
          await Promise.all(keys.filter((key) => key.startsWith("valenpos-")).map((key) => window.caches.delete(key)));
        }
        cachesCleaned = true;
      } catch (error) {
        console.warn("No se pudo limpiar la caché de desarrollo", error);
      }
      // Unregistering does not release the currently controlled page. Reload at
      // most once per tab; if sessionStorage is unavailable, do not auto-reload.
      const reloadKey = "valenpos-dev-sw-reloaded";
      try {
        if (!wasControlled) window.sessionStorage.removeItem(reloadKey);
        else if (registrationsCleaned && cachesCleaned && !window.sessionStorage.getItem(reloadKey)) {
          window.sessionStorage.setItem(reloadKey, "1");
          window.location.reload();
        }
      } catch { /* A manual refresh is sufficient in restricted browsers. */ }
    };
    if (document.readyState === "complete") void cleanDevelopmentWorker();
    else window.addEventListener("load", cleanDevelopmentWorker, { once: true });
  } else {
  const registerServiceWorker = () => {
    const swUrl = `/sw.js?v=${encodeURIComponent(APP_VERSION)}`;
    navigator.serviceWorker
      .register(swUrl)
      .then((reg) => {
        let refreshing = false;

        const reloadWhenReady = (worker) => {
          if (!worker) return;
          worker.postMessage({ type: "SKIP_WAITING" });
          worker.addEventListener("statechange", (e) => {
            if (e.target.state === "activated" && !refreshing) {
              refreshing = true;
              window.location.reload();
            }
          });
        };

        // SW ya esperando
        if (reg.waiting && navigator.serviceWorker.controller) {
          reloadWhenReady(reg.waiting);
        }

        // SW nuevo encontrado
        reg.addEventListener("updatefound", () => {
          const newWorker = reg.installing;
          if (!newWorker) return;
          newWorker.addEventListener("statechange", () => {
            if (
              newWorker.state === "installed" &&
              navigator.serviceWorker.controller
            ) {
              reloadWhenReady(newWorker);
            }
          });
        });

        // Seguridad extra: si el controller cambia, refresca una sola vez
        navigator.serviceWorker.addEventListener("controllerchange", () => {
          if (refreshing) return;
          refreshing = true;
          window.location.reload();
        });
      })
      .catch((err) => {
        console.warn("No se pudo registrar el Service Worker", err);
      });
  };

  window.addEventListener("load", registerServiceWorker);
  }
}
